import { render, staticRenderFns } from "./RenderSlots.vue?vue&type=template&id=fc49fd18&scoped=true&"
import script from "./RenderSlots.vue?vue&type=script&lang=js&"
export * from "./RenderSlots.vue?vue&type=script&lang=js&"
import style0 from "./RenderSlots.vue?vue&type=style&index=0&id=fc49fd18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc49fd18",
  null
  
)

export default component.exports